import anime from './anime.min.js';
let aniLottery;
class Turntable {
    constructor(target) {
        this.opts = {
            target, // 旋转对象
            easing: 'easeInOutSine', // anime.js 动画曲线
            isplay: false, // 动画是否在播放
            duration: 3000, // 动画时长
            rotateNum: 5, // 旋转圈数
            total: 9, // 奖励个数
            offset: 0 // 旋转偏移值
        };
        aniLottery = anime({
            targets: target
        });
        this.opts.angle = 360 / this.opts.total; // 旋转角度
    }
    start(index, cb) {
        if (this.opts.isplay) {
            return;
        }
        this.reset();
        this.opts.isplay = true;
        let self = this,
            opt = this.opts,
            angle = opt.angle,
            off = (opt.total - index) * angle - angle / 2 - opt.offset;

        aniLottery = anime({
            targets: this.opts.target,
            easing: this.opts.easing,
            autoplay: false,
            duration: this.opts.duration,
            rotate: opt.rotateNum * 360 + off,
            complete() {
                const dom = document.querySelector(self.opts.target);
                if (dom) {
                    dom.cssText = `transform: rotate(${off})deg`;
                    self.stop();
                    cb && cb(index);
                }
                // $(self.opts.target).css({
                //     '-webkit-transform': `rotate(${off}deg)`,
                //     'transform': `rotate(${off}deg)`
                // });
            }
        });
        aniLottery.restart();
    }
    stop() {
        this.opts.isplay = false;
        aniLottery.pause();
    }

    reset() {
        aniLottery = anime({
            targets: this.opts.target,
            easing: this.opts.easing,
            autoplay: true,
            duration: 0,
            rotate: 0
        });
    }

    static create(opts) {
        return new Turntable(opts);
    }
}

export default Turntable;
